import axios from "axios";
import { useEffect, useState } from "react";


const useSpots = () => {
    const [spots, setSpots] = useState([]);
    useEffect(() => {
        axios.get(`https://tripaide-server.onrender.com/spots`)
            .then(res => {
                setSpots(res.data);
            })
    }, []);
    return [spots, setSpots]
};

export default useSpots;